import { BaseComponentProps, BaseField } from "./baseComponentProps";
import React from "react";

export class Slider extends React.Component<SliderProps, any>{
    private _sliderRef: HTMLInputElement;
    private _slider: kendo.ui.Slider;
    private _value: number;
    private _disabled: boolean = true;
    private _id: string;

    componentWillUnmount() {
        this._slider.destroy();
    }

    componentDidMount() {
        this._id = kendo.guid();
        this._disabled = this.props.disabled;
        this._value = this.props.value;
        this._slider = $(this._sliderRef).kendoSlider({
            min: this.props.field.min,
            max: this.props.field.max,
            smallStep: this.props.field.smallStep,
            largeStep: this.props.field.largeStep,
            value: this._value,
            tooltip: {
                template: "#let sliderValue = $('\\#" + this._id + "').data('slider-value');# #=sliderValue#"
            },
            change: (ev) => {
                this._value = ev.sender.value();
                this.props.onChange(this.props.field, ev.sender.value(), null);
                $(this._sliderRef).data("slider-value", ev.sender.value());
            },
            slide: (ev) => {
                $(this._sliderRef).data("slider-value", ev.value);
            }
        }).data("kendoSlider");
        $(this._sliderRef).attr("id", this._id);
        $(this._sliderRef).data("slider-value", this.props.value);
        this._slider.enable(!this._disabled);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this._disabled !== this.props.disabled) {
            this._disabled = this.props.disabled;
            this._slider.enable(!this._disabled);
        }
        if (this._value !== this.props.value) {
            this._value = this.props.value;
            this._slider.value(this._value);
            $(this._sliderRef).data("slider-value", this._value);
        }
    }

    render() {
        return (
            <div>
                <input ref={(r) => this._sliderRef = r} name={this.props.field.name} style={this.props.style || { width: "100%", marginBottom: "20px" } as React.CSSProperties} required={this.props.required} />
            </div>
        );
    }
}
export interface SliderProps extends BaseComponentProps {
    field: SliderField;
    style?: React.CSSProperties;
}

export interface SliderField extends BaseField {
    smallStep?: number;
    largeStep?: number;
    min?: number;
    max?: number;
    value?: number;
}